import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
import { ButtonStylingModel } from '../button/button-styling.model';
export class WizardStylingModel extends CoreStylingModel {
/**
 * Styling of wizard header section
 */
headerSection?: StylingModel;
/**
 * Styling of navigation buttons section
 */
navigationSection?: StylingModel;
/**
 * Styling by type ButtonStylingModel
 */
backButton?: ButtonStylingModel;
/**
 * Styling by type ButtonStylingModel
 */
nextButton?: ButtonStylingModel;
/**
 * Styling by type ButtonStylingModel
 */
finishButton?: ButtonStylingModel;
/**
 * It is the constructor for the WizardStylingModel. It takes the values to create the WizardStylingModel object.
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function WizardStylingModel_tsickle_Closure_declarations() {
/**
 * Styling of wizard header section
 * @type {?}
 */
WizardStylingModel.prototype.headerSection;
/**
 * Styling of navigation buttons section
 * @type {?}
 */
WizardStylingModel.prototype.navigationSection;
/**
 * Styling by type ButtonStylingModel
 * @type {?}
 */
WizardStylingModel.prototype.backButton;
/**
 * Styling by type ButtonStylingModel
 * @type {?}
 */
WizardStylingModel.prototype.nextButton;
/**
 * Styling by type ButtonStylingModel
 * @type {?}
 */
WizardStylingModel.prototype.finishButton;
}

